import { isMobileVR } from "../utils/is-mobile";
import { getNetworkedEntity } from "../utils/scene-graph";

AFRAME.registerComponent("inspect-button", {
  schema: {
    disableOnMobile: { default: false }
  },
  init() {
    if (this.data.disableOnMobile && AFRAME.utils.device.isMobileVR()) {
      // Remove and return;
      this.el.remove();
      return;
    }

    this.targetEl = null;

    getNetworkedEntity(this.el).then(networkedEl => {
      this.targetEl = networkedEl;
    });

    this.onClick = () => {
      if (!isMobileVR() && this.data.disableOnMobile) {
        return;
      }

      this.el.sceneEl.systems["hubs-systems"].cameraSystem.inspect(this.targetEl, 1.5);
    };
  },
  play() {
    this.el.object3D.addEventListener("interact", this.onClick);
  },
  pause() {
    this.el.object3D.removeEventListener("interact", this.onClick);
  },
  tick() {
    if (!this.initializedInTick) {
      // initialize in tick so that parent's `tags` component has been initialized
      this.initializedInTick = true;
      this.el.object3D.addEventListener("holdable-button-down", () => {
        this.el.sceneEl.systems["hubs-systems"].cameraSystem.inspect(this.targetEl, 1.5);
      });
      this.el.object3D.addEventListener("holdable-button-up", () => {
        this.el.sceneEl.systems["hubs-systems"].cameraSystem.uninspect();
      });
    }
  }
});
